/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { FilingRecords } from '../models/filing-records';
import { FormFilterForException } from '../models/form-filter-for-exception';
import { MultiDiscard } from '../models/multi-discard';
@Injectable({
  providedIn: 'root',
})
class FilingRecordsService extends __BaseService {
  static readonly getFilingRecordsPath = '/filingRecords/list';
  static readonly saveFilingRecordPath = '/filingRecords/save';
  static readonly discardFilingRecordPath = '/filingRecords/discard';
  static readonly multiDiscardFilingRecordPath = '/filingRecords/multi-discard';
  static readonly revertDiscardFilingRecordPath = '/filingRecords/discard/revert';
  static readonly getDiscardFilingRecordsListPath = '/filingRecords/discardFilings';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param filingRecordsFilter undefined
   * @return returns a list of filingRecords that crawled and valid for manual intervention.
   */
  getFilingRecordsResponse(filingRecordsFilter: FormFilterForException): __Observable<__StrictHttpResponse<Array<FilingRecords>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = filingRecordsFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filingRecords/list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FilingRecords>>;
      })
    );
  }
  /**
   * @param filingRecordsFilter undefined
   * @return returns a list of filingRecords that crawled and valid for manual intervention.
   */
  getFilingRecords(filingRecordsFilter: FormFilterForException): __Observable<Array<FilingRecords>> {
    return this.getFilingRecordsResponse(filingRecordsFilter).pipe(
      __map(_r => _r.body as Array<FilingRecords>)
    );
  }

  /**
   * @param filingRecord undefined
   * @return result if the filingRecord was saved.
   */
  saveFilingRecordResponse(filingRecord: FilingRecords): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = filingRecord;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filingRecords/save`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param filingRecord undefined
   * @return result if the filingRecord was saved.
   */
  saveFilingRecord(filingRecord: FilingRecords): __Observable<boolean> {
    return this.saveFilingRecordResponse(filingRecord).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `FilingRecordsService.DiscardFilingRecordParams` containing the following parameters:
   *
   * - `recordId`:
   *
   * - `reason`:
   *
   * @return it will return boolean weather record is discarded or not
   */
  discardFilingRecordResponse(params: FilingRecordsService.DiscardFilingRecordParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.recordId != null) __params = __params.set('recordId', params.recordId.toString());
    if (params.reason != null) __params = __params.set('reason', params.reason.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filingRecords/discard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `FilingRecordsService.DiscardFilingRecordParams` containing the following parameters:
   *
   * - `recordId`:
   *
   * - `reason`:
   *
   * @return it will return boolean weather record is discarded or not
   */
  discardFilingRecord(params: FilingRecordsService.DiscardFilingRecordParams): __Observable<boolean> {
    return this.discardFilingRecordResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param multiDiscard undefined
   * @return it will return boolean weather records are discarded or not
   */
  multiDiscardFilingRecordResponse(multiDiscard?: MultiDiscard): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = multiDiscard;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filingRecords/multi-discard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param multiDiscard undefined
   * @return it will return boolean weather records are discarded or not
   */
  multiDiscardFilingRecord(multiDiscard?: MultiDiscard): __Observable<boolean> {
    return this.multiDiscardFilingRecordResponse(multiDiscard).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `FilingRecordsService.RevertDiscardFilingRecordParams` containing the following parameters:
   *
   * - `recordId`:
   *
   * - `reason`:
   *
   * @return it will return boolean weather record is discarded or not
   */
  revertDiscardFilingRecordResponse(params: FilingRecordsService.RevertDiscardFilingRecordParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.recordId != null) __params = __params.set('recordId', params.recordId.toString());
    if (params.reason != null) __params = __params.set('reason', params.reason.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filingRecords/discard/revert`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `FilingRecordsService.RevertDiscardFilingRecordParams` containing the following parameters:
   *
   * - `recordId`:
   *
   * - `reason`:
   *
   * @return it will return boolean weather record is discarded or not
   */
  revertDiscardFilingRecord(params: FilingRecordsService.RevertDiscardFilingRecordParams): __Observable<boolean> {
    return this.revertDiscardFilingRecordResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param filingRecordsFilter undefined
   * @return returns a list of filingRecords that crawled and valid for manual intervention.
   */
  getDiscardFilingRecordsListResponse(filingRecordsFilter: FormFilterForException): __Observable<__StrictHttpResponse<Array<FilingRecords>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = filingRecordsFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filingRecords/discardFilings`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FilingRecords>>;
      })
    );
  }
  /**
   * @param filingRecordsFilter undefined
   * @return returns a list of filingRecords that crawled and valid for manual intervention.
   */
  getDiscardFilingRecordsList(filingRecordsFilter: FormFilterForException): __Observable<Array<FilingRecords>> {
    return this.getDiscardFilingRecordsListResponse(filingRecordsFilter).pipe(
      __map(_r => _r.body as Array<FilingRecords>)
    );
  }
}

module FilingRecordsService {

  /**
   * Parameters for discardFilingRecord
   */
  export interface DiscardFilingRecordParams {
    recordId: number;
    reason: string;
  }

  /**
   * Parameters for revertDiscardFilingRecord
   */
  export interface RevertDiscardFilingRecordParams {
    recordId: number;
    reason: string;
  }
}

export { FilingRecordsService }
